import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/E3_OneTimeCharge.svg'

const E3OneTimeCharge: React.FC<SvgIconProps> = props => <SvgIcon viewBox="0 0 76 76" component={Icon} {...props} fill="currentColor" />
export default E3OneTimeCharge
